import { Injectable } from '@angular/core';
import { Store } from 'src/app/core/services/store.service';
import { CheckedLiabilities, CheckedLiability } from '../models/cart-state.model';
import { Liability } from '../../liabilities/models/liability.model';

@Injectable({
  providedIn: 'root',
})
export class CheckedLiabilitiesStoreService extends Store<CheckedLiabilities> {

  constructor() {
    super(null, 'CheckedLiabilities');

    if (!this.state) {
      let state = {
        checkedLiabilities: [],
        checkedLiabilitiesAmount: 0,
      };
      this.setState(state);

    }
  }


  remove(id: string) {
    let currentState = this.state;
    if (currentState && currentState.checkedLiabilities) {
      currentState.checkedLiabilities = currentState.checkedLiabilities.filter(value => value.id !== id);
    }
    currentState = this.refreshState(currentState);
    this.setState(currentState);
  }
  removeList(ids: string[]) {
    let currentState = this.state;
    if (currentState && currentState.checkedLiabilities) {
      currentState.checkedLiabilities = currentState.checkedLiabilities.filter(value => !ids.includes(value.id));
    }
    currentState = this.refreshState(currentState);
    this.setState(currentState);
  }

  addCheckedLiabilityList(liabilities: CheckedLiability[]) {
    let currentState = this.state;
    if (!currentState || !currentState.checkedLiabilities) {
      currentState.checkedLiabilities = [];
    }
    liabilities.forEach(liability => {
      if (this.state.checkedLiabilities.findIndex(value => liability.id === value.id) === -1) {
        currentState.checkedLiabilities.push(liability);
      }
    });
    currentState = this.refreshState(currentState);
    this.setState(currentState);
  }

  addCheckedLiability(checkedLiability: CheckedLiability) {
    let currentState = this.state;
    if (!currentState || !currentState.checkedLiabilities) {
      currentState.checkedLiabilities = [];
    }
    if (currentState.checkedLiabilities.findIndex(value => checkedLiability.id === value.id) === -1) {
      currentState.checkedLiabilities.push(checkedLiability);
      currentState = this.refreshState(currentState);
      this.setState(currentState);
    }
  }

  addLiability(liability: Liability) {
    let currentState = this.state;
    if (!currentState || !currentState.checkedLiabilities) {
      currentState.checkedLiabilities = [];
    }
    if (currentState.checkedLiabilities.findIndex(value => liability.id === value.id) === -1) {
      currentState.checkedLiabilities.push(
        {
          id: liability.id,
          amountToPay: liability.amountToPay,
        },
      );
      currentState = this.refreshState(currentState);
      this.setState(currentState);
    }
  }

  addLiabilityList(liabilities: Liability[]) {
    let currentState = this.state;
    if (!currentState || !currentState.checkedLiabilities) {
      currentState.checkedLiabilities = [];
    }

    liabilities.forEach(liability => {
      if (currentState.checkedLiabilities.findIndex(value => liability.id === value.id) === -1) {
        currentState.checkedLiabilities.push(
          {
            id: liability.id,
            amountToPay: liability.amountToPay,
          },
        );
      }
    });
    currentState = this.refreshState(currentState);
    this.setState(currentState);
  }

  public getIds() {
    if (this.state && this.state.checkedLiabilities) {
      return this.state.checkedLiabilities.map(value => value.id);
    } else {
      return [];
    }
  }

  public clearCheckedLiabilities() {
    this.state.checkedLiabilities = [];
    this.setState(this.state);
  }

  public sumLiabilities(liabilities: CheckedLiability[]) {
    if (!liabilities) {
      return 0;
    } else {
      return liabilities.reduce((sum, currentValue) => sum + currentValue.amountToPay, 0);

    }
  }

  public refreshState(state: CheckedLiabilities) {
    state.checkedLiabilitiesAmount = this.sumLiabilities(state.checkedLiabilities);
    return state;
  }

}
